module.exports = __webpack_public_path__ + "ce35b00b861cf55bfd155a9c43954c87.png";